"use client"

import * as React from "react"
import { Moon, Sun } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useThemeAnimation } from "@/hooks/use-theme-animation"

export function ModeToggle() {
    const [mounted, setMounted] = React.useState(false)
    const { setThemeWithAnimation } = useThemeAnimation()

    React.useEffect(() => {
        setMounted(true)
    }, [])

    const handleThemeChange = React.useCallback((newTheme: string, event: React.MouseEvent) => {
        event.preventDefault()
        setThemeWithAnimation(newTheme, event)
    }, [setThemeWithAnimation])

    if (!mounted) {
        return <Button variant="outline" size="icon" disabled className="opacity-0" />
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="icon">
                    <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
                    <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
                    <span className="sr-only">Toggle theme</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem
                    onSelect={(e) => e.preventDefault()}
                    onClick={(e) => handleThemeChange("light", e)}
                >
                    Light
                </DropdownMenuItem>
                <DropdownMenuItem
                    onSelect={(e) => e.preventDefault()}
                    onClick={(e) => handleThemeChange("dark", e)}
                >
                    Dark
                </DropdownMenuItem>
                <DropdownMenuItem
                    onSelect={(e) => e.preventDefault()}
                    onClick={(e) => handleThemeChange("system", e)}
                >
                    System
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
